import React from 'react';
import styled from 'styled-components';
import FormInput from './common/FormInput';
import FormContainer from './common/FormContainer';
import InputContainer from './common/InputContainer';

const Button = styled.button<{ isLoading: boolean }>`
  background-color: ${props => props.isLoading ? '#ccc' : (props.theme.primary || '#e74c3c')};
  color: white;
  border: none;
  border-radius: 12px;
  padding: 0.85rem 1.5rem;
  cursor: ${props => props.isLoading ? 'not-allowed' : 'pointer'};
  font-weight: 700;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  height: 100%;
  min-width: 120px;
  box-shadow: 0 4px 6px ${props => props.theme.primary ? `${props.theme.primary}1A` : 'rgba(231, 76, 60, 0.1)'};

  &:hover:not(:disabled) {
    background-color: ${props => props.theme.secondary || '#c0392b'};
    transform: translateY(-1px);
    box-shadow: 0 6px 12px ${props => props.theme.primary ? `${props.theme.primary}33` : 'rgba(231, 76, 60, 0.2)'};
  }
`;

const ErrorMessage = styled.div`
  color: ${props => props.theme.primary || '#e74c3c'};
  font-size: 0.8rem;
  margin-top: 0.5rem;
`;

interface ZipCodeFormModalProps {
  zipCode: string;
  setZipCode: (zipCode: string) => void;
  onSubmit: () => void;
  isLoading: boolean;
  error: string | null;
}

const ZipCodeFormModal: React.FC<ZipCodeFormModalProps> = ({
  zipCode,
  setZipCode,
  onSubmit,
  isLoading,
  error
}) => {
  const handleZipCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Remove all non-numeric characters
    const numericValue = value.replace(/\D/g, '');
    // Format as 99999-999
    if (numericValue.length <= 5) {
      setZipCode(numericValue);
    } else {
      setZipCode(
        numericValue.slice(0, 5) + 
        '-' + 
        numericValue.slice(5, 8)
      );
    }
  };

  return (
    <FormContainer>
      <InputContainer>
        <FormInput 
          label="Digite seu CEP"
          type="text" 
          value={zipCode}
          onChange={handleZipCodeChange}
          placeholder="00000-000"
        />
        <Button 
          onClick={onSubmit}
          isLoading={isLoading}
          disabled={isLoading}
        >
          {isLoading ? 'Buscando...' : 'Buscar'}
        </Button>
      </InputContainer>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </FormContainer>
  );
};

export default ZipCodeFormModal;